import React, { useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import { FiArrowRight, FiClock, FiSearch } from 'react-icons/fi';
import SeoHead from '../components/SeoHead';
import { useContent } from '../context/ContentContext';
import '../components/Blog.css';
import './BlogListPage.css';

const BlogListPage = () => {
  const { blogs, ready } = useContent();
  const [query, setQuery] = useState('');
  const [active, setActive] = useState('All');

  const categories = useMemo(() => {
    const set = new Set(blogs.map((b) => b.category).filter(Boolean));
    return ['All', ...Array.from(set)];
  }, [blogs]);

  const filtered = useMemo(() => {
    return blogs.filter((b) => {
      const okCat = active === 'All' || b.category === active;
      if (!okCat) return false;
      if (!query) return true;
      const q = query.toLowerCase();
      return (
        b.title?.toLowerCase().includes(q) ||
        b.excerpt?.toLowerCase().includes(q) ||
        b.author?.toLowerCase().includes(q)
      );
    });
  }, [blogs, query, active]);

  return (
    <>
      <SeoHead title="Blog" description="Playbooks, teardowns, and case studies from THINKINGWORLD on web, mobile, IoT, SEO and digital marketing." path="/resources/blog" />

      <header className="page-header">
        <div className="container">
          <span className="section-eyebrow">Blog</span>
          <h1>Playbooks, teardowns, and case studies.</h1>
          <p>Practical writing on web, mobile, IoT, SEO and digital marketing — for businesses that want to grow online.</p>
        </div>
      </header>

      <section className="section">
        <div className="container">
          <div className="blog-filters">
            <div className="blog-search">
              <FiSearch />
              <input
                type="search"
                placeholder="Search by title, author, category…"
                value={query}
                onChange={(e) => setQuery(e.target.value)}
              />
            </div>
            <div className="blog-cats">
              {categories.map((c) => (
                <button
                  key={c}
                  className={`blog-cat ${c === active ? 'blog-cat--active' : ''}`}
                  onClick={() => setActive(c)}
                  type="button"
                >
                  {c}
                </button>
              ))}
            </div>
          </div>

          {!ready && <p className="blog-empty">Loading…</p>}
          {ready && filtered.length === 0 && (
            <p className="blog-empty">No articles match your filter.</p>
          )}

          <div className="blog-grid">
            {filtered.map((p) => (
              <Link key={p.id} to={`/resources/blog/${p.slug || p.id}`} className="blog-card">
                <div className="blog-cover">
                  {p.cover ? (
                    <img src={p.cover} alt={p.title} onError={(e) => { e.currentTarget.style.display = 'none'; }} />
                  ) : (
                    <div className="blog-cover-placeholder" />
                  )}
                  <span className="blog-category">{p.category}</span>
                </div>
                <div className="blog-body">
                  <div className="blog-meta">
                    <span>{p.date}</span>
                    {p.readTime && <span><FiClock /> {p.readTime}</span>}
                  </div>
                  <h3 className="blog-title">{p.title}</h3>
                  <p className="blog-excerpt">{p.excerpt}</p>
                  <span className="blog-link">
                    Read article <FiArrowRight />
                  </span>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default BlogListPage;
